import React, { useCallback, useEffect, useState } from "react";
import { getUpcomingBookings } from "../../../utils/APIs/bookingsApis";
import BookingsTable from "../BookingsTable/BookingsTable";
import "./UpcommingBookingsTable.css"
import Loader from "../../../Loader/Loader";
// import AddBookingModal from "./AddBookingModal/AddBookingModal";
const LIMIT = 10;

const UpcommingBookingsTable = () => {
  const [data, setData] = useState([]);
  const [fromDate, setFromDate] = useState("");
  //  const [isModalOpen, setIsModalOpen] = useState(false);
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(() => {
    const savedPage = sessionStorage.getItem("upcommingBookingPage");
    return savedPage ? Number(savedPage) : 1;
  });
  const [total, setTotal] = useState(0);
  const today = new Date().toISOString().split("T")[0];

  useEffect(() => {
    sessionStorage.setItem("upcommingBookingPage", page);
  }, [page]);
  // 🔹 USING YOUR fetchData (FIXED ONLY)
  const fetchData = useCallback(async (pageNumber = page) => {
    try {
      setLoading(true);
      const response = await getUpcomingBookings(
        fromDate,
        toDate,
        pageNumber,
        LIMIT
      );

      if (response?.data?.success) {
        setData(response.data.data || []);
        // Handle different meta structures
        const totalItems = response.data.meta?.total ?? response.data.total ?? 0;
        setTotal(totalItems);
        setPage(response.data.meta?.page ?? pageNumber);
      }
    } catch (error) {
      console.error("Fetch upcoming bookings error:", error);
    } finally {
      setLoading(false);
    }
  }, [fromDate, toDate, page]);


  useEffect(() => {
    fetchData(page);
  }, [page, fetchData]);


  const totalPages = Math.ceil(total / LIMIT);

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 3;
    let start = Math.max(1, page - 2);
    let end = Math.min(totalPages, page + 2);

    if (end - start < maxVisible - 1) {
      if (start === 1) {
        end = Math.min(totalPages, start + maxVisible - 1);
      } else if (end === totalPages) {
        start = Math.max(1, end - maxVisible + 1);
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  };


  return (
    <>
      {/* Filters */}
      <div className="filters-bar">
        <div className="filters">
          <div>
            <label>From Date</label>
            <input
              type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
              min={today}
            />
          </div>

          <div>
            <label>To Date</label>
            <input
              type="date" onClick={(e) => { if(e.target.showPicker) e.target.showPicker(); }}
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
              min={today}
            />
          </div>

          <button
            onClick={() => fetchData(1)}
            className="filter-btn"
            disabled={loading}
          >
            Apply
          </button>
        </div>




      </div>


      {/* Table */}
      {loading && data.length === 0 ? (
        <Loader />
      ) : (
        <BookingsTable data={data} page={page} limit={LIMIT} refetchData={fetchData} />
      )}

      {/* Pagination */}
      {total > LIMIT && (
        <div className="pagination">
          {/* Prev */}
          <button
            className="pagination-btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            Prev
          </button>

          {/* Page Numbers */}
          {getPageNumbers().map((p) => (
            <button
              key={p}
              className={`pagination-btn ${p === page ? "active" : ""}`}
              onClick={() => setPage(p)}
            >
              {p}
            </button>
          ))}

          {/* Next */}
          <button
            className="pagination-btn"
            disabled={page === totalPages}
            onClick={() => setPage(page + 1)}
          >
            Next
          </button>
        </div>
      )}

    </>
  );
};

export default UpcommingBookingsTable;
